const converterBlobParaBase64 = async (blob) => {
  let codigoBase64 = null
  const conversao = blobParaBase64(blob)
  await conversao.then((resultado) => {
    codigoBase64 = resultado
  })
  codigoBase64 = codigoBase64.substr(codigoBase64.indexOf(',') + 1)
  return codigoBase64
}

const blobParaBase64 = blob => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})

const downloadArquivoUrl = async (url, nomeArquivo) => {
  await fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const urlObject = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = urlObject
      a.download = nomeArquivo
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(urlObject)
    })
    .catch(error => {
      console.error('Erro ao realizar o download:', error)
      throw error
    })
}

export default {
  converterBlobParaBase64,
  downloadArquivoUrl
}
